export type Frame = {
  id: string;
  displayUnitId?: string;
  broadsignFrameId?: string;
  leader?: string;
  name: string;
  publisher: string;
  environment: string;
  formatSize: string;
  resolution: string;
  status: Status | null;
};

export const initialFrameState: Frame = {
  id: '',
  displayUnitId: '',
  broadsignFrameId: '',
  leader: '',
  name: '',
  publisher: '',
  environment: '',
  formatSize: '',
  resolution: '',
  status: null,
};

export type Status = {
  state: State;
  time: string;
};

export enum State {
  MIA = 'MIA',
  IN_ERROR = 'IN_ERROR',
  LOW_DELIVERY = 'LOW_DELIVERY',
  OK = 'OK',
  DEACTIVATED = 'DEACTIVATED',
}

export type PageResponse = {
  items: Frame[];
  totalElements: number;
  page: number;
  totalPages: number;
};
